import { render } from "./Chefs.vue?vue&type=template&id=315a9d8c"
import script from "./Chefs.vue?vue&type=script&lang=js"
export * from "./Chefs.vue?vue&type=script&lang=js"
script.render = render

export default script